import React from 'react';
import { FunctionTypes } from '../../../components/ContributorSection/helpers';
import { PubMainTypeEnum, PubSuffixTypeEnum, SourceType } from '../../../types';
export var TabHeaders;
(function (TabHeaders) {
  TabHeaders["Online"] = "Online";
  TabHeaders["InPrint"] = "In-Print";
  TabHeaders["OnlineDatabase"] = "Online database";
})(TabHeaders || (TabHeaders = {}));
export var getSourceWasOptions = function getSourceWasOptions(source) {
  return [{
    key: PubSuffixTypeEnum.PUB_ONLINE,
    value: 'Originally in print but found online',
    main: source === SourceType.MAGAZINE ? PubMainTypeEnum.PUB_MAGAZINE : PubMainTypeEnum.PUB_NEWSPAPER
  }, {
    key: PubSuffixTypeEnum.PUB_NONE,
    value: 'Published directly online',
    main: PubMainTypeEnum.PUB_ONLINE
  }];
};
export var magazineNewspaperDropdownOptions = {
  Magazine: 'Magazine article',
  Newspaper: 'Newspaper article',
  MagazineEditorial: "Editorial found in a Magazine",
  MagazineReview: 'Review found in a Magazine',
  NewspaperEditorial: "Editorial found in a Newspaper",
  NewspaperReview: 'Review found in a Newspaper'
};
export var getCitingOptions = function getCitingOptions(source) {
  return [{
    uuid: SourceType.MAGAZINE,
    value: source,
    child: /*#__PURE__*/React.createElement(React.Fragment, null, source === SourceType.MAGAZINE ? magazineNewspaperDropdownOptions.Magazine : magazineNewspaperDropdownOptions.Newspaper)
  }, {
    uuid: SourceType.EDITORIAL,
    value: SourceType.EDITORIAL,
    child: /*#__PURE__*/React.createElement(React.Fragment, null, source === SourceType.MAGAZINE ? magazineNewspaperDropdownOptions.MagazineEditorial : magazineNewspaperDropdownOptions.NewspaperEditorial)
  }, {
    uuid: SourceType.REVIEW,
    value: SourceType.REVIEW,
    child: /*#__PURE__*/React.createElement(React.Fragment, null, source === SourceType.MAGAZINE ? magazineNewspaperDropdownOptions.MagazineReview : magazineNewspaperDropdownOptions.NewspaperReview)
  }];
};
export var PREFIX_FOR_TEST_IDS = 'magazine-form';
export var MAGAZINE_PUBLICATION_INFO = 'Magazine publication info';
export var NEWSPAPER_PUBLICATION_INFO = 'Newspaper publication info';
export var ONLINE_DATABASE_PUB_INFO = 'Online database publication info';
export var WEBSITE_PUB_INFO = 'Website publication info';
export var TestIds = {
  MAGAZINE_ONLINE_DB_PUB_INFO_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-online-db-pub-info-sec-test-id"),
  MAGAZINE_WEBSITE_PUB_INFO_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-website-pub-info-sec-test-id"),
  MAGAZINE_PUB_INFO_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-magazine-pub-info-sec-test-id")
};
export var MagazineNewspaperContributorFunctions = [FunctionTypes.AUTHOR, FunctionTypes.EDITOR, FunctionTypes.COMPILER, FunctionTypes.TRANSLATOR];